import { Box, useMediaQuery, useTheme, Stack } from '@mui/material';
import { ReactNode } from 'react';
import Layout from '../../layouts/default-layout';
import HeaderWithBackNav from '../ui-header-back';

type backHeaderProps = {
    enabled: boolean;
    title: string;
};
type FlexBoxProps = {
    children: ReactNode;
    backHeader: backHeaderProps;
};

export default function FlexBox({children, backHeader} : FlexBoxProps) {
    const theme = useTheme();
    const desktopView = useMediaQuery(theme.breakpoints.up("sm"));
    return (
        <Layout>
            <center>
                <Box bgcolor={desktopView ? theme.palette.secondary.main : ""} borderRadius={1} padding={2} width={desktopView ? "60%" : "100%"}>
                    {backHeader.enabled && <HeaderWithBackNav text={backHeader.title} size={"md"} target={"-1"} />}
                    <Stack gap={2} style={{minWidth: '200px'}}>
                        {children}
                    </Stack>
                </Box>
            </center>
        </Layout>
    );
}